module.exports = __webpack_public_path__ + "images/emoji/pensive.89677a7f539d006d9c1d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pensive.png
// module id = PgaS
// module chunks = 14